<template>
  <v-footer id="nav" color="#fff">
    <v-container>
      <div class="d-flex align-center justify-space-between footer-box">
        <a class="logo" href="orders">
          <v-img v-if="logo" :src="logo" width="82px"></v-img>
          <v-img v-else src="../assets/logo-plus.png" width="82px"></v-img>
        </a>

        <div class="d-flex align-center footer-menu">
          <a :href="faqUrl" target="_blank">{{ $t('faq-footer') }}</a>
          <a :href="faqAppUrl" target="_blank">{{ $t('faq-app-footer') }}</a>
        </div>

        <v-spacer></v-spacer>

        <div class="copyright-footer">
          &copy; {{ $t('copyright', { currentYear: this.$store.state.currentYear })
          }}<span>|</span> <router-link :to="{ name: 'help' }">{{ $t('disclaimer') }}</router-link
          ><span>|</span>
          <a href="https://collectgo.eu/privacy" target="_blank">{{ $t('privacy_policy') }}</a>
        </div>
      </div>
    </v-container>
  </v-footer>
</template>

<script>
export default {
  computed: {
    logo() {
      return this.$store.state.loginUser.logo
        ? `data:image/jpeg;base64,${this.$store.state.loginUser.logo}`
        : null;
    },
    faqUrl() {
      const lang = this.$store.state.language;
      return `https://collectgo.eu/${lang || 'en'}/faq`;
    },
    faqAppUrl() {
      const lang = this.$store.state.language;
      return `https://collectgo.eu/${lang || 'en'}/faq-app`;
    },
  },
};
</script>
